export const UPLOAD_STATUS = {
  // Waiting for upload
  INITIALIZING: 'INITIALIZING',

  // Upload to oss
  UPLOADING: 'UPLOADING',
  UPLOAD_SUCCESS: 'UPLOAD_SUCCESS',
  UPLOAD_FAILED: 'UPLOAD_FAILED',
  CANCEL_UPLOAD: 'CANCEL_UPLOAD',
  CANCEL_UPLOAD_SUCCESS: 'CANCEL_UPLOAD_SUCCESS',
  CANCEL_UPLOAD_FAILED: 'CANCEL_UPLOAD_FAILED',

  // For upload command
  PROCESSING: 'PROCESSING',
  PROCESS_FAILED: 'PROCESS_FAILED',
};

export const FOLDER_LIMIT = 200;
export const SEARCH_FOLDER_LIMIT = 100;
export const DOCUMENT_LIMIT = 50;

export const FILE_ERROR_CODES = {
  ERR_NOT_ALLOWED: 'ERR_NOT_ALLOWED', // 403
  ERR_RESOURCE_NOT_EXIST: 'ERR_RESOURCE_NOT_EXIST', // 404
};
